import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import moment from 'moment'

import Financials from './modules/Financials/Financials'
import Rightmove from './modules/Rightmove/Rightmove';


import {authAgentOSSignIn, authAgentOSSignOut} from './agentosAuth'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //Dev API
    // ------------------------------------------
    //baseURL: 'https://test1-api.letmc.com',
    //apiKey: 'yrR5n2TUHYH44ybHgYhGdre5k-ze6fUwLI7UTNzKjuI1',

    //Live API
    // ------------------------------------------
    baseURL: 'https://live-api.letmc.com',
    apiKey: 'YMKFS-Jzlo-ArdDuH9rz6YfGwr9gPD0nqGQ_GFeBZyg1',

    userSpecific: 0,
    user: null,
    activeUser: '',
    errorMessages: [],
    reportDate: new moment().startOf('month'),
    reportMonth: new moment().startOf('month').format("MMMM YYYY"),
    reportMonthStart: new moment().startOf('month'),
    reportMonthEnd: new moment().endOf('month'),
    currencyData : ''
  },
  mutations: {
    SET_ERROR(state, data) {
      state.errorMessages.push(data)
    },
    SET_USER_DATA(state, userData) {
      state.user = userData
      localStorage.setItem('user', JSON.stringify(userData))
      axios.defaults.headers.common['Authorization'] = `Bearer ${userData.LoginToken}`
    },
    CLEAR_USER_DATA(state) {
      state.userSpecific = '',
      state.user = null,
      state.activeUser = '',
      state.errorMessages = []
    },
    SET_ACTIVE_USER(state, data){
      state.activeUser = data.ActiveUser
    },
    SET_REPORT_DATE(state, data){
      state.reportDate = data;
      state.reportMonthStart = data;
      state.reportMonthEnd = moment(data).endOf('month');
    },
    SET_REPORT_MONTH(state, data){
      state.reportMonth = data;
    },
    SET_CURRENCY_DATA(state,data){
      state.currencyData = data;
    }
  },
  actions: {
    // LOGIN / AUTHENTICATION + SESSION-STATUS & BRANCH SELECTOR
    // ------------------------------------------------------------------------
    // ------------------------------------------------------------------------


    login({commit, dispatch, state}, credentials) {
      return axios({
        method: 'POST',
        url: `${state.baseURL}/corporate/ownerapp/letmcletting/session/login`,
        data: {
          Username: credentials.username,
          Password: credentials.password,
        },
        headers: {
        //  api_key: credentials.api_key
         api_key: state.apiKey
        },
      })
      .then(({data}) => {
        commit('SET_USER_DATA', data);
        authAgentOSSignIn(state.user.UserOID, state.user.UserDisplayName, state.user.UserToken).then(() => {
          dispatch('dispatchActions')
        });
        
      })
    },
    loginAgentOSSessionID({commit, dispatch, state}, credentials) {
      return axios({
        method: 'POST',
        url: `${state.baseURL}/corporate/agentapp/letmcletting/session/loginsessionid`,
        data: {
          ShortName: credentials.shortName,
          SessionID: credentials.sessionID,
        },
        headers: {
        //  api_key: credentials.api_key
         api_key: state.apiKey
        },
      })
      .then(({data}) => {
        commit('SET_USER_DATA', data)
        authAgentOSSignIn(state.user.UserOID, state.user.UserDisplayName, state.user.UserToken).then(() => {
          dispatch('sessionStatus')
        });
      })
      
    },
    dispatchActions({dispatch}) {
      dispatch('sessionStatus')
      dispatch('getCurrencyData')
      dispatch("Financials/getLettingsForecast");
      dispatch("Financials/getSalesForecast");
    },
    sessionStatus({state, commit, dispatch}) {
      return axios({
        method: 'GET',
        url: `${state.baseURL}/corporate/ownerapp/letmcletting/${state.user.ClientName}/session/status`,
        headers: {
          token: state.user.LoginToken,
          api_key: state.apiKey
        }
      })
      .then( ({data}) => {
            commit('SET_ACTIVE_USER', data)
        }
      )
       .catch( () => {
         dispatch('logout')
       })
    },
    getCurrencyData({state, commit}) {
      return axios({
        method: 'GET',
        url: `${state.baseURL}/corporate/ownerapp/letmcletting/${state.user.ClientName}/company/currency`,
        headers: {
          token: state.user.LoginToken,
          api_key: state.apiKey
        }
      })
      .then( ({data}) => {
            commit('SET_CURRENCY_DATA', data)
            console.log(data);
        }
      )
    },
    logout({commit, state}) {
      return axios({
        method: 'DELETE',
        url: `${state.baseURL}/corporate/ownerapp/letmcletting/${state.user.ClientName}/session/logout`,
        headers: {
          token: state.user.LoginToken,
          api_key: state.apiKey
        }
      })
      .then( () => {
        commit('CLEAR_USER_DATA')
        authAgentOSSignOut().then(() => {
        
        });
      })
    },
    addMonthToReportDate({commit, state}){
      let reportDate = state.reportDate.add(1, 'M');
      commit("SET_REPORT_DATE", reportDate);
      commit("SET_REPORT_MONTH", reportDate.format("MMMM YYYY"))
      
    },
    removeMonthFromReportDate({commit, state}){
      let reportDate = state.reportDate.add(-1, 'M');
      commit("SET_REPORT_DATE", reportDate);
      commit("SET_REPORT_MONTH", reportDate.format("MMMM YYYY"))
    }
  },

  methods: {
  },
  getters: {
    loggedIn(state) {
      return !!state.user
    },
    returnUserFirstName(state) {
      let activeUser = state.activeUser
      var firstName = activeUser.replace(/ .*/,'')
      return firstName
    },
    toCurrency() {
    return function(state, value) {
      if (typeof value !== "number") {
        return value;
      }
      var formatter = new Intl.NumberFormat(state.LocaleCode, {
        style: 'currency',
        currency: state.CurrencyCode,
        minimumFractionDigits: state.CurrencyFractionDigits,
        maximumFractionDigits: state.CurrencyFractionDigits
      });
      return formatter.format(value);
    }
  }
    ,
  }, 
  modules: {
    Financials,
    Rightmove
  },

})
